{/* Auto-generated icon - do not edit */}
import React from 'react'

interface PopsicleIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const PopsicleIcon = React.forwardRef<SVGSVGElement, PopsicleIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 71 153"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M46.0479 111.974C46.3183 114.607 46.5298 116.915 46.7962 119.217C47.6416 126.529 46.9138 133.783 45.8315 140.997C45.2393 144.588 43.33 147.83 40.4764 150.09C37.4573 152.621 34.7079 152.078 32.0097 149.187C29.5773 146.582 28.8932 143.629 28.9024 140.276C28.9266 131.074 28.9026 121.872 28.8901 112.669C28.8495 112.218 28.7817 111.769 28.6873 111.325C24.1671 111.09 19.5944 110.948 15.0395 110.583C11.6967 110.314 8.36686 109.818 5.05434 109.279C4.05679 109.138 3.12991 108.685 2.40687 107.983C1.84439 107.354 1.3442 105.953 1.67106 105.377C2.70742 103.553 2.49085 101.668 2.43572 99.7985C2.13774 89.708 1.76296 79.6194 1.42429 69.5302C1.13419 60.8947 0.702285 52.2605 0.61893 43.6237C0.531637 34.6444 2.219 25.9683 6.55674 18.0037C11.1419 9.58481 17.6239 3.19743 27.2845 1.16737C38.6267 -1.21579 47.9048 2.90658 54.8764 11.7888C57.6639 15.3409 59.5843 19.6649 61.4267 23.8477C65.2691 32.7187 67.5181 42.1975 68.0701 51.8491C69.0179 66.4001 69.7904 80.9623 70.5832 95.5231C70.7657 98.8704 70.9586 102.237 69.3237 105.411C68.9004 106.233 69.1452 107.38 68.9791 108.358C68.5702 110.769 67.9572 111.497 65.4961 111.636C61.3611 111.871 57.213 111.89 53.0702 111.964C50.8531 112.01 48.6352 111.974 46.0479 111.974ZM62.5535 104.96C62.2955 102.9 62.0286 101.586 61.9807 100.264C61.4911 87.0354 61.149 73.7997 60.5367 60.5763C60.135 51.9547 59.4759 43.3245 57.1236 34.9582C55.3587 28.6921 53.2455 22.5311 49.7728 16.9653C43.4982 6.90759 29.7289 3.68107 19.9094 12.793C12.8978 19.2993 9.56487 27.5389 8.90328 36.6429C8.16556 46.7998 8.32571 57.0399 8.47798 67.2382C8.64469 78.4544 9.32518 89.6633 8.26519 100.87C8.1733 101.837 8.25272 102.821 8.25272 104.111C26.4451 104.896 44.3252 105.338 62.5557 104.96H62.5535ZM36.9268 141.942L37.8456 141.934C39.9571 131.958 39.2628 121.9 38.6433 111.684H35.2382C35.8092 121.914 36.3676 131.928 36.9268 141.942Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="70.8845" height="151.614" fill={color} transform="translate(0.0732422 0.431641)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

PopsicleIcon.displayName = 'PopsicleIcon'
